window.boostarpAlert = function () {
  let _self = [];
  _self.content = document.getElementsByClassName('alert-content')[0];
  _self.templateWarning = function (text) {
    return `<div class="alert alert-warning alert-dismissible fade show" role="alert">
                ${text}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>`;
  }
  _self.templateSuccess = function (text) {
    return `<div class="alert alert-success  alert-dismissible fade show" role="alert">
                ${text}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>`;
  }
  _self.templateError = function (text) {
    return `<div class="alert alert-danger  alert-dismissible fade show" role="alert">
                ${text}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>`;
  }

  _self.addAlert = function (text) {
    _self.content.innerHTML += _self.templateWarning(text);
    setInterval(function () {
      _self.content.innerHTML = ""
    }, 6000);
  }

  _self.addSuccess = function (text) {
    _self.content.innerHTML += _self.templateSuccess(text);
    setInterval(function () {
      _self.content.innerHTML = ""
    }, 6000);
  }
  _self.addError = function (text) {
    _self.content.innerHTML += _self.templateError(text);
    setInterval(function () {
      _self.content.innerHTML = ""
    }, 6000);
  }

  return {
    addAlert: _self.addAlert,
    addSuccess: _self.addSuccess,
    addError: _self.addError,
  }

}
